var Handlebars = require("/home/jenkins/workspace/朵颐 - 发布POS前台/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var alias1=container.escapeExpression, alias2=depth0 != null ? depth0 : (container.nullContext || {});

  return "<ul class=\"itemList hidden\" data-catid=\""
    + alias1(container.lambda((depth0 != null ? depth0.id : depth0), depth0))
    + "\">\n    <div class=\"newItemBtnDiv\">\n        <button class=\"btn btn-lg btn-success blue-btn newItem\">\n            "
    + alias1(__default(require("/home/jenkins/workspace/朵颐 - 发布POS前台/src/hbHelpers/i18n.js")).call(alias2,"pos.setting.menu.newitem",{"name":"i18n","hash":{},"data":data}))
    + "\n        </button>\n    </div>\n    <div class=\"blankDiv\">\n    </div>\n    <li class=\"ech\">\n        "
    + alias1(__default(require("/home/jenkins/workspace/朵颐 - 发布POS前台/src/hbHelpers/i18n.js")).call(alias2,"pos.setting.menu.emptyCategory",{"name":"i18n","hash":{},"data":data}))
    + "\n    </li>\n</ul>";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/templates/pos/settings/MenuItem.handlebars
// module id = 607
// module chunks = 0